import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_kratos';
import WaterMark from "../../DashboardMain_Kratos/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import CommanBarTable_Kratos from "../CommanBarTable_Kratos";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result

function MaxCellTemp_cycles_Kratos({ apiend, gloablfilter, type, maxCellTemp_Option, chartnameFCD }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  let barcolor
  let toPush = [];
  let toPushfast = [];
  const appyDataCycles = (data) => {
    res_result = data;
    toPush = [];
    let responce = {
      "<=20": 0,
      "22": 0,
      "24": 0,
      "26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      "44": 0,
      ">44": 0,
    }

    if (res_result.length !== 0) {
      let d = res_result[0];

      if (d.B1.value)
        responce["<=20"] = d.B1.value
      if (d.B2.value)
        responce["22"] = d.B2.value
      if (d.B3.value)
        responce["24"] = d.B3.value
      if (d.B4.value)
        responce["26"] = d.B4.value
      if (d.B5.value)
        responce["28"] = d.B5.value
      if (d.B6.value)
        responce["30"] = d.B6.value
      if (d.B7.value)
        responce["32"] = d.B7.value
      if (d.B8.value)
        responce["34"] = d.B8.value
      if (d.B9.value)
        responce["36"] = d.B9.value
      if (d.B10.value)
        responce["38"] = d.B10.value
      if (d.B11.value)
        responce["40"] = d.B11.value
      if (d.B12.value)
        responce["42"] = d.B12.value
      if (d.B13.value)
        responce["44"] = d.B13.value
      if (d.B14.value)
        responce[">44"] = d.B14.value

      toPush.push(d.B1.value)
      toPush.push(d.B2.value)
      toPush.push(d.B3.value)
      toPush.push(d.B4.value)
      toPush.push(d.B5.value)
      toPush.push(d.B6.value)
      toPush.push(d.B7.value)
      toPush.push(d.B8.value)
      toPush.push(d.B9.value)
      toPush.push(d.B10.value)
      toPush.push(d.B11.value)
      toPush.push(d.B12.value)
      toPush.push(d.B13.value)
      toPush.push(d.B14.value)

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }
      loop_keys.map(x => {
        if (countcheck)
          // barcolor
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      const labels = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "deg Celcius",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'deg Celcius'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycles'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'deg Celcius',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: 'short',

    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#3578b0" },
    },
  };

  const [tempMaxTemp, setTempMaxTemp] = useState("")
  useEffect(() => {
    setTempMaxTemp(maxCellTemp_Option)
    settoPushPopUp([])
    fetchData({ url: API_URL_MAIN + "kratos_charge/" + apiend, body: { filterdata: gloablfilter, maxCellTemp_Option: maxCellTemp_Option } }, appyDataCycles)
    barcolor = "#3578b0"
    SetChartName(chartnameFCD);
  }, [gloablfilter, type, maxCellTemp_Option])

  const [toPushPopUp, settoPushPopUp] = useState([]);
  const appyDataClick = (data) => {
    let toPushPopUpArr = []
    let hits = data;

    hits.map((i, key) => {
      toPushPopUpArr.push({
        "key": {
          "vehicleId": i.key.vehicleId,
          "Depot_Name": i.key.Depot_Name,
          "DLR_ORG_CITY": i.key.DLR_ORG_CITY,
          "vehicle_registration_number": i.key.vehicle_registration_number
        },
        "doc_count": 9,
        [tempMaxTemp]: {
          "values": {
            "50.0": i.doc_count
          }
        }
      })
    })
    toPushPopUpArr.sort((a, b) => b[tempMaxTemp].values["50.0"] - a[tempMaxTemp].values["50.0"]);
    settoPushPopUp(toPushPopUpArr)
  }

  let labelsForPopup = ["20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", "44+"]

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
        {
          eventName: "select",
          callback({ chartWrapper }) {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            const [selectedItem] = selection;
            const { row } = selectedItem;
            // const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);

            let from_bucket;
            let to_bucket;

            if (row === 0) {
                  from_bucket = (0)?.toFixed(2)
                to_bucket = (20)?.toFixed(2)
                }
                else if (row === labelsForPopup.length - 1) {
                from_bucket = (44)?.toFixed(2)
                to_bucket = null
                }
                else{
                   from_bucket = Number(labelsForPopup[row - 1])?.toFixed(2)
                   to_bucket = Number(labelsForPopup[row])?.toFixed(2)
                }
            // const count = chartWrapper.getDataTable().Wf[row].c[1].v;
            // if (count !== 0) {
              // if (barvalue === "<=20") {
              //   from_bucket = 0
              //   to_bucket = 20
              // } else if (barvalue === ">44") {
              //   from_bucket = 44
              //   to_bucket = null
              // } else {
              //   from_bucket = barvalue - 2
              //   to_bucket = barvalue
              // }

              fetchData({ url: API_URL_MAIN + "kratos_charge/max_cell_temp_cycles_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket), maxCellTemp_Option: tempMaxTemp } }, appyDataClick)
              window.$('#exampleModal__' + apiend).modal('show');
            // }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
            <div className="modal-body">
              {/* <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">Cycles Count</th>
                  </tr></thead>
                <tbody> */}
              <CommanBarTable_Kratos data={toPushPopUp} tabDataKey={tempMaxTemp} />
              {/* </tbody></table> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MaxCellTemp_cycles_Kratos;